<template>
  <nav class="navbar navbar-expand-md bg-dark shadow">
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        @click="collapse?.toggle()"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <NuxtLink class="navbar-brand" @click="collapse?.hide()" :to="{ path: '/' }"
          ><img :src="ICImg" height="24" width="32" alt="bahnvorhersage logo"
        /></NuxtLink>
        <div class="navbar-nav me-auto">
          <NuxtLink
            class="nav-item nav-link"
            @click="collapse?.hide()"
            :to="{ path: '/journey-search-result', hash: '#content' }"
            >Suche</NuxtLink
          >
          <div class="nav-item dropdown">
            <NuxtLink
              class="nav-link dropdown-toggle"
              @click="collapse?.hide()"
              :to="{ path: '/routing' }"
              >Alpha</NuxtLink
            >
            <div class="dropdown-menu shadow rounded">
              <NuxtLink
                class="nav-item nav-link"
                @click="collapse?.hide()"
                :to="{ path: '/routing' }"
                >Alternativen</NuxtLink
              >
              <NuxtLink
                class="nav-item nav-link"
                @click="collapse?.hide()"
                :to="{ path: '/routing/explanation' }"
                >Funktionsweise</NuxtLink
              >
            </div>
          </div>
          <div class="nav-item dropdown">
            <NuxtLink
              class="nav-link dropdown-toggle"
              @click="collapse?.hide()"
              data-toggle="dropdown"
              :to="{ path: '/stats', hash: '#content' }"
              >Statistiken</NuxtLink
            >
            <div class="dropdown-menu shadow rounded">
              <NuxtLink
                class="nav-link"
                @click="collapse?.hide()"
                :to="{ path: '/stats/overview', hash: '#content' }"
                >Übersicht</NuxtLink
              >
              <NuxtLink
                class="nav-link"
                @click="collapse?.hide()"
                :to="{ path: '/stats/stations', hash: '#content' }"
                >Bahnhöfe</NuxtLink
              >
            </div>
          </div>
          <div class="nav-item dropdown">
            <NuxtLinkLocale
              class="nav-link dropdown-toggle"
              @click="collapse?.hide()"
              data-toggle="dropdown"
              :to="{ path: '/open-data' }"
              >Open Data</NuxtLinkLocale
            >
            <div class="dropdown-menu shadow rounded">
              <NuxtLinkLocale
                class="nav-link"
                @click="collapse?.hide()"
                :to="{ path: '/open-data/stops' }"
                >{{ t('stops') }}</NuxtLinkLocale
              >
              <NuxtLinkLocale
                class="nav-link"
                @click="collapse?.hide()"
                :to="{ path: '/open-data/parsed-train-delays' }"
                >{{ t('parsedData') }}</NuxtLinkLocale
              >
              <NuxtLinkLocale
                class="nav-link"
                @click="collapse?.hide()"
                :to="{ path: '/open-data/raw-data' }"
                >{{ t('rawData') }}</NuxtLinkLocale
              >
            </div>
          </div>
          <NuxtLink class="nav-item nav-link" @click="collapse?.hide()" :to="{ path: '/blog' }"
            >Blog</NuxtLink
          >
        </div>
      </div>
      <div class="d-flex gap-2">
        <NuxtLink class="btn btn-primary" @click="collapse?.hide()" :to="{ path: '/app' }"
          >App</NuxtLink
        >
        <a
          href="https://mastodon.social/@mctoel"
          target="_blank"
          aria-label="Mastodon"
          rel="noopener noreferrer"
          class="btn btn-primary"
          ><i class="icon icon-mastodon"></i
        ></a>
        <NuxtLink
          class="btn btn-primary"
          @click="collapse?.hide()"
          :to="{ path: '/opensource', hash: '#content' }"
          ><i class="icon icon-gitlab"></i> Code & Docs</NuxtLink
        >
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { Collapse } from 'bootstrap'
import ICImg from '~/assets/img/IC.svg'

const { t } = useI18n({ useScope: 'local' })

const collapse = ref(null as Collapse | null)

onMounted(() => {
  collapse.value = new Collapse('#navbarSupportedContent', {
    toggle: false
  })
})
</script>

<style lang="scss">
.navbar .dropdown-menu {
  display: block;
}

.dropdown-menu .nav-link {
  padding-left: 1rem !important;
}

@include media-breakpoint-up(md) {
  .navbar .nav-item .dropdown-menu {
    display: none;
  }

  .navbar .nav-item:hover .dropdown-menu {
    display: block;
  }

  .navbar .nav-item .dropdown-menu {
    margin-top: 0;
  }
}
</style>

<i18n lang="yaml">
de:
  stops: Haltestellen
  parsedData: Geparste Zugverspätungen
  rawData: Rohdaten Zugverspätungen
en:
  stops: Stops
  parsedData: Parsed train delays
  rawData: Raw data
</i18n>
